import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { atletePhotosFunc } from "../../../../data-store/actions/atlete-actions";
import {
  athleteJuezRegistries,
  createJuezRegistry,
} from "../../../../data-store/actions/events-actions";

import AtleteControls from "./AtleteControls";
import AtleteCharts from "./AtleteCharts";
import AtletePhotos from "./AtletePhotos";
import { puntoFotograficoPrevRuta } from "../../../../firebase/firebasejs";
import SimpleDialogDemo from "../../Modals/SimpleDialog";
import FormRender from "../../../Fields/FormRender";
import { Typography } from "@material-ui/core";
import usePuntosControl from "../../../../services/usePuntosControl";

export default function CreateRegistryJuezFromPhoto(props) {
  const dispatch = useDispatch();
  const { photo } = props;
  const userID = useSelector((state) => state.atlete.userID);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const puntosControl = usePuntosControl();

  useEffect(() => {
    //dispatch();
    //athleteJuezRegistries("evento_" + eventDetail.iDEvento, resultado.num)
  }, []);

  function onSubmit(data) {
    console.log("data", data);

    const object = {
      competidorId: userID,
      fechaHora: data.fecha + " " + data.hora,
      iDEvento: eventDetail.iDEvento,
      kPuntoControl: data.kPuntoControl,
      lat: 1,
      lng: 1,
      numero: data.numero,
      timeStamp: new Date(data.fecha + "T" + data.hora).getTime(),
      visibleOBorrado: data.visibleOBorrado ? 1 : 0,
    };

    dispatch(createJuezRegistry(object, false, null));
  }

  function selectList(object) {
    let array = [];
    for (var i in object) {
      array.push({
        label: object[i].descripcionFinalPunto,
        value: object[i].kNroPunto,
      });
    }

    return array;
  }
  function selectListTime(top) {
    let array = [];
    for (var i = 0; i <= top; i++) {
      const seconds = i < 10 ? "0" + i : i;
      array.push({
        label: seconds,
        value: seconds,
      });
    }

    return array;
  }

  console.log("photo.horaAjustada", photo.horaAjustada);
  const dateFormat = new Date(photo.horaAjustada);
  console.log("dateFormat", dateFormat.getSeconds());
  const fecha = photo.horaAjustada.split(" ")[0];
  const horaSplit = photo.horaAjustada.split(" ")[1].split(":");
  const hora = photo.horaAjustada.split(" ")[1];
  let createEventObject = {
    numero: {
      label: "Número Observado",
      errorMessage: "Campo Requerido",
      fieldName: "numero",
      type: "text",
      defaultValue: 0,
      required: true,
      min: 0,
      regex: "",
      textSize: "h6",
    },
    kPuntoControl: {
      label: "Punto de Control",
      errorMessage: "Campo Requerido",
      fieldName: "kPuntoControl",
      type: "select",
      defaultValue: 0,
      required: true,
      regex: "",
      textSize: "h6",
      optionsArray: selectList(puntosControl),
    },
    fecha: {
      label: "Fecha",
      errorMessage: "Campo Requerido",
      fieldName: "fecha",
      type: "date",
      defaultValue:
        fecha.split("-")[0] +
        "-" +
        fecha.split("-")[1] +
        "-" +
        fecha.split("-")[2],
      required: true,
      regex: "",
      textSize: "h6",
    },
    hora: {
      label: "Hora, minutos, segundos y milisegundos (00:00:00.000)",
      errorMessage: "Revisa el formato (00:00:00.000)",
      fieldName: "hora",
      type: "text",
      defaultValue: hora,
      required: true,
      regex:
        "^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]:[0-5][0-9].[0-9][0-9][0-9]$",
      textSize: "h6",
    },
  };
  return (
    <div style={{ padding: "40px", minWidth: "500px" }}>
      <Typography gutterBottom variant={"h6"} component="h5">
        Hora Original:
      </Typography>
      <Typography gutterBottom variant={"h5"} component="h2">
        {photo.horaAjustada}
        {eventDetail.fechaHora}
      </Typography>
      <FormRender
        callback={onSubmit}
        formObject={createEventObject}
        submitButtonText={"Guardar Registro"}
      />
    </div>
  );
}
